<template>
  <v-autocomplete
    v-if="allSelectorOptions.length > 0"
    v-model="selected"
    :items="allSelectorOptions"
    :loading="loading"
    label="Группы"
    item-value="id"
    item-text="name"
    :search-input.sync="search"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    multiple
    :rules="rule"
    :disabled="disabled"
    ref="groupSelector"
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length <= 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small v-for="groupId in selected" :key="`group_selector${groupId}`" >
          <span class="sliced-name">{{ allSelectorOptions.find(g => g.id === groupId).name }}</span>
        </v-chip>
      </span>

      <span v-else class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ allSelectorOptions.find(g => g.id === selected[0]).name }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{selected.length - 1}})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{toggleAllText}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
  <v-progress-circular
    v-else
    color="success"
    indeterminate
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { axios } from '~/plugins/axios';

export default {
  name: 'GroupSelector',
  props: {
    value: {
      required: true,
    },
    single: Boolean,
    disabled: Boolean,
    noRules: Boolean,
    reloadAgents: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      allSelectorOptions: [],
      loading: false,
      search: '',
      rule: [
        v => {
          if (this.noRules || this.disabled) return true
          else
            return !!v.length || 'Данное поле обязательно'
        }
      ],
    }
  },

  computed: {
    ...mapGetters({}),

    selected: {
      get() {
        return this.value;
      },
      set(selected) {
        this.$emit("input", selected);
      },
    },

    filteredItems() {
      if (this.allSelectorOptions.length > 0 && this.$refs.groupSelector != undefined) return this.$refs.groupSelector.filteredItems;
      else return [];
    },

    allItems() {
      return this.selected.length > 0 && this.selected.join("") === this.filteredItems.map(i => i.id).join("");
    },

    moreItems() {
      return this.selected.length > 0 && !this.allItems;
    },

    icon() {
      if (this.allItems) return "mdi-close-box";
      if (this.moreItems) return "mdi-plus-box";
      return "mdi-checkbox-blank-outline";
    },

    toggleAllText() {
      if (this.allItems) return "Отменить все";
      if (this.moreItems) return "Выбрать все";
      return "Выбрать все";
    },
  },

  watch: {
    selected(val) {
      if (val.length > 0) {
        this.loadIncludedAgents(val);
      } else {
        this.$emit('change:users', [])
      }

      if (this.single) {
        if (val.length > 1) this.value.pop()
      }
    },
  },

  methods: {
    ...mapActions({
      loadAllGroups: 'graphql/loadAllGroups',
    }),

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = [];
        } else {
          this.selected = this.filteredItems.map((i) => i.id);
        }
      });
    },

    async refresh() {
      this.selected = [];
      this.search = '';
    },

    async loadIncludedAgents(val) {
      if (!this.reloadAgents) return;

      this.loading = true;

      let query = {
        query: `{
          users (groups_ids: ${JSON.stringify(val)}) {
            data {
              id
            }
          }
        }`
      };

      let res = await axios.post('/api/graphql', query)
        .then(resp => resp.data.data.users.data.map(u => u.id))
        .catch(er => console.log(er));

      this.$emit('change:users', res);

      this.loading = false;

      return res;
    },

  },

  async mounted() {
    this.allSelectorOptions = await this.loadAllGroups();
  }
}
</script>

<style scoped lang="scss">
.sliced-name {
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>